import { FunctionComponent, useCallback, useState } from 'react';
import { ButtonGroup, Button, Flex } from '@chakra-ui/react';
import { ArrowUpIcon } from '@chakra-ui/icons';

type SpeedSelectionProps = {
    value: TransactionSpeed;
    onChange: (value: string) => void;
};

export type TransactionSpeed = 'slow' | 'medium' | 'fast' | 'custom';

const SpeedSelection: FunctionComponent<SpeedSelectionProps> = ({
    value,
    onChange,
}) => {
    return (
        <ButtonGroup size='sm' isAttached variant='outline'>
            <Button
                mr='-px'
                isActive={value === 'slow'}
                onClick={onChange ? () => onChange('slow') : undefined}
            >
                Lenta
            </Button>
            <Button
                mr='-px'
                isActive={value === 'medium'}
                onClick={onChange ? () => onChange('medium') : undefined}
            >
                Media
            </Button>
            <Button
                mr='-px'
                isActive={value === 'fast'}
                onClick={onChange ? () => onChange('fast') : undefined}
            >
                Veloce
            </Button>
        </ButtonGroup>
    );
};

export default SpeedSelection;
